var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(Object.keys(_vm.comment))?_c('app-note-editor',{attrs:{"row-data":_vm.comment,"note-title":_vm.$t('payment_note'),"note-description":_vm.comment,"edit-permission":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }